// extracted by mini-css-extract-plugin
export default {"colorBox":"ColorBox_colorBox__upmJN","swatch":"ColorBox_swatch__sLrRG","color":"ColorBox_color__q8kkS"};